import { AUDIT_CATEGORY, AuditCategoryType } from '@/types/auditLogTypes';

export const ALL_CATEGORIES = 'all';

/** Pills in demo order; the three technical ones come last. */
export const AUDIT_PILLS: { key: AuditCategoryType | typeof ALL_CATEGORIES; label: string }[] = [
  { key: ALL_CATEGORIES, label: 'All' },
  { key: AUDIT_CATEGORY.LINKS, label: 'Links' },
  { key: AUDIT_CATEGORY.VERIFY, label: 'Verification' },
  { key: AUDIT_CATEGORY.CONSENT, label: 'Consent' },
  { key: AUDIT_CATEGORY.VAULT, label: 'Vault changes' },
  { key: AUDIT_CATEGORY.INSURED, label: 'Insured transactions' },
  { key: AUDIT_CATEGORY.ACTIVITY, label: 'Activity' },
  { key: AUDIT_CATEGORY.CHANGES, label: 'Data changes' },
];

export const SOURCE_LABEL: Record<string, string> = {
  domain: 'Platform event',
  api: 'API request',
  ui: 'User interface',
  data: 'Data change',
  system: 'System task',
};

export const EXPORT_FILE_NAME = 'wirevault-audit-log.csv';
